// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style-module_warningIcon__tqc0tGTuJYXlI5abcOqQ"};